/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated';
import { createUnaryMinus } from '../../factoriesAny.js';
export var unaryMinusDependencies = {
  typedDependencies: typedDependencies,
  createUnaryMinus: createUnaryMinus
};